module.exports = __webpack_public_path__ + "img/qyb.7334508a.jpg";